import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";
import "summernote/dist/summernote-bs4.css"; // Bootstrap 4 theme

import axiosInstance from "../../axiosInstance";
import Select from "react-select";
import "./EventForm.scss";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import { useAuth } from "../../contexts/AuthContext";

const EventForm = ({ categoryId, onClose, scheduledEventId }) => {
  const { user, isLoading: isAuthLoading } = useAuth();

  const [taskName, setTaskName] = useState("");
  const [eventType, seteventType] = useState([]);
  const [selectedEventType, setSelectedEventType] = useState("");

  const [isSummernoteInitialized, setIsSummernoteInitialized] = useState(false);

  const [notificationHeader, setNotificationHeader] = useState("");
  const [notificationBody, setNotificationBody] = useState("");

  const [fromEmail, setFromEmail] = useState("RESPECTIVE_EMPLOYEE");
  const [specificEmail, setSpecificEmail] = useState("");

  // State for company email configs
  const [companyEmailConfigs, setCompanyEmailConfigs] = useState([]);
  const [selectedCompanyEmail, setSelectedCompanyEmail] = useState("");

  const [toEmail, setToEmail] = useState("CANDIDATE");

  const [specificEmails, setSpecificEmails] = useState([]);

  const [departments, setDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [emp, setEmp] = useState([]);

  // New state for company email to configs
  const [selectedCompanyEmailToConfigs, setSelectedCompanyEmailToConfigs] =
    useState([]);

  const [messageHeading, setMessageHeading] = useState("");

  const [emailContent, setEmailContent] = useState("");
  const summernoteRef = useRef(null);

  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  const [loading, setLoading] = useState(false);

  const [notificationTypes, setNotificationTypes] = useState([]);
  const [selectedNotificationTypes, setSelectedNotificationTypes] = useState(
    [],
  );

  const [placeholders, setPlaceholders] = useState([]);
  const [specificEmailConfigs, setSpecificEmailConfigs] = useState([]);

  // Holds the raw fetched record for the event being edited so that
  // from-email matching can be (re)run once companyEmailConfigs /
  // specificEmailConfigs have actually finished loading (see matching
  // useEffect below).
  const [savedEventData, setSavedEventData] = useState(null);

  // Add these new state variables and refs after existing state declarations
  const [activeField, setActiveField] = useState("");

  // Add refs for input fields
  const notificationHeaderRef = useRef(null);
  const notificationBodyRef = useRef(null);
  const messageHeadingRef = useRef(null);

  const fromEmailOptions = [
    { value: "SPECIFIC", label: "Specific" },
    { value: "COMPANY", label: "Company" },
    { value: "RESPECTIVE_EMPLOYEE", label: "Respective Employee" },
    { value: "RESPECTIVE_ACCOUNTANT", label: "Respective Accountant" },
    { value: "RESPECTIVE_MANAGER", label: "Respective Manager" },
    { value: "RESPECTIVE_HR", label: "Respective Hr" },
  ];

  const toEmailOptions = [
    { value: "CANDIDATE", label: "Candidate" },
    { value: "DEPARTMENT", label: "Department" },
    { value: "BRANCH", label: "Branch" },
    { value: "ROLE", label: "Role" },
    { value: "ALLEMP", label: "All Employees" },
    { value: "SPECIFIC_EMPLOYEES", label: "Specific Employees" },
    { value: "COMPANY", label: "Company" },
    { value: "RESPECTIVE_EMPLOYEE", label: "Respective Employee" },
    { value: "RESPECTIVE_MANAGER", label: "Respective Manager" },
    { value: "RESPECTIVE_HR", label: "Respective Hr" },
    { value: "RESPECTIVE_ACCOUNTANT", label: "Respective Accountant" },
  ];

  const mapDisplayToEnumValue = (displayValue, optionsArray) => {
    const option = optionsArray.find((opt) => opt.label === displayValue);
    return option ? option.value : displayValue;
  };

  // Initialize Summernote
  useEffect(() => {
    if (summernoteRef.current && !isSummernoteInitialized) {
      $(summernoteRef.current).summernote({
        height: 300,
        width: "100%",
        placeholder: "Enter email content here...",
        theme: "bs4", // Using Bootstrap 4 theme (Sandstone style)
        toolbar: [
          ["style", ["style"]],
          [
            "font",
            [
              "bold",
              "underline",
              "italic",
              "strikethrough",
              "superscript",
              "subscript",
              "clear",
            ],
          ],
          ["fontname", ["fontname"]],
          ["fontsize", ["fontsize"]],
          ["color", ["forecolor", "backcolor"]],
          ["para", ["ul", "ol", "paragraph", "height"]],
          ["table", ["table"]],
          ["insert", ["link", "picture", "video", "hr"]],
          ["view", ["fullscreen", "codeview", "help"]],
          ["misc", ["undo", "redo"]],
        ],
        fontNames: [
          "Arial",
          "Arial Black",
          "Comic Sans MS",
          "Courier New",
          "Helvetica",
          "Impact",
          "Tahoma",
          "Times New Roman",
          "Verdana",
        ],
        fontSizes: [
          "8",
          "9",
          "10",
          "11",
          "12",
          "14",
          "16",
          "18",
          "20",
          "24",
          "36",
          "48",
        ],
        callbacks: {
          onChange: (contents) => {
            setEmailContent(contents);
          },
          onFocus: () => {
            setActiveField("emailBody");
          },
          onBlur: () => {
            // Don't immediately clear activeField, give some delay
            setTimeout(() => {
              setActiveField(null);
            }, 100);
          },
          onInit: () => {
            // Set initial content after initialization if available
            if (emailContent) {
              setTimeout(() => {
                $(summernoteRef.current).summernote("code", emailContent);
              }, 100);
            }
          },
        },
      });
      setIsSummernoteInitialized(true);
    }

    // Cleanup function
    return () => {
      if (summernoteRef.current && isSummernoteInitialized) {
        try {
          $(summernoteRef.current).summernote("destroy");
          setIsSummernoteInitialized(false);
        } catch (error) {
          console.warn("Error destroying Summernote:", error);
        }
      }
    };
  }, [isSummernoteInitialized]);

  // Update Summernote content when emailContent changes programmatically
  useEffect(() => {
    if (isSummernoteInitialized && summernoteRef.current && emailContent) {
      const currentContent = $(summernoteRef.current).summernote("code");
      // Only update if content is different to avoid cursor issues
      if (currentContent !== emailContent) {
        // Store cursor position if Summernote is focused
        const isFocused = $(summernoteRef.current)
          .next(".note-editor")
          .find(".note-editable")
          .is(":focus");

        setTimeout(() => {
          $(summernoteRef.current).summernote("code", emailContent);

          // Restore focus if it was previously focused
          if (isFocused) {
            $(summernoteRef.current).summernote("focus");
          }
        }, 100);
      }
    }
  }, [emailContent, isSummernoteInitialized]);

  useEffect(() => {
    if (scheduledEventId) {
      fetchEventDetails(scheduledEventId);
    }
  }, [scheduledEventId]);

  // Company emails are needed for both the "From: Company" and
  // "To: Company" pickers regardless of this record's source, so fetch
  // them eagerly, same as departments/branches/roles/etc. Specific email
  // configs (admin/hr `/email-config`) are only relevant when "Specific"
  // is actually the from-email source, so that fetch is triggered by the
  // effect below instead of firing on every single edit/create.
  useEffect(() => {
    fetchCompanyEmailConfigs();
  }, []);

  // Fetch specific email configs only when "Specific" is actually the
  // selected from-email source — either because the user picked it while
  // creating a new notification, or because it's set to "SPECIFIC" once
  // the edited record's saved source comes back from fetchEventDetails.
  // This avoids hitting /email-config for records that use Company/
  // Respective Employee/etc.
  useEffect(() => {
    if (fromEmail === "SPECIFIC" && specificEmailConfigs.length === 0) {
      fetchSpecificEmailConfigs();
    }
  }, [fromEmail, specificEmailConfigs.length]);

  const fetchCompanyEmailConfigs = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/company/email-config/All`,
      );
      setCompanyEmailConfigs(response.data.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching company email configurations:", error);
      setLoading(false);
    }
  };

  const fetchSpecificEmailConfigs = async () => {
    try {
      setLoading(true);

      const userAuthorities = user.authorities || [];

      let apiEndpoint = "";
      if (userAuthorities.includes("ROLE_HR")) {
        apiEndpoint = `${process.env.REACT_APP_API_HR_URL}/email-config`;
      } else if (userAuthorities.includes("ROLE_ADMIN")) {
        apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/email-config`;
      } else {
        console.warn("No matching role for email configs");
        setLoading(false);
        return;
      }

      const response = await axiosInstance.get(apiEndpoint);
      console.log("Email config response:", response.data); // Debug log

      // Handle different response structures
      let emailConfigs = [];
      if (response.data && Array.isArray(response.data.data)) {
        emailConfigs = response.data.data;
      } else if (response.data && Array.isArray(response.data)) {
        emailConfigs = response.data;
      } else if (
        response.data &&
        response.data.data &&
        !Array.isArray(response.data.data)
      ) {
        // If data is a single object, wrap it in an array
        emailConfigs = [response.data.data];
      }

      setSpecificEmailConfigs(emailConfigs);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching specific email configurations:", error);
      setSpecificEmailConfigs([]); // Set to empty array on error
      setLoading(false);
    }
  };

  // Function to detect if content contains HTML
  const containsHTML = (content) => {
    if (!content) return false;

    // Remove whitespace and check if it contains HTML tags
    const trimmedContent = content.trim();

    // Check for common HTML tags
    const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;

    // Check for HTML entities
    const htmlEntityRegex = /&[a-zA-Z0-9#]+;/;

    // Check for Summernote's default HTML structure (even empty content has some HTML)
    const hasSignificantHTML =
      htmlTagRegex.test(trimmedContent) &&
      !trimmedContent.match(/^<p><br><\/p>$|^<p><\/p>$|^<br>$/);

    return hasSignificantHTML || htmlEntityRegex.test(trimmedContent);
  };

  const fetchEventDetails = async (id) => {
    try {
      setLoading(true);

      const userAuthorities = user.authorities || [];

      let apiEndpoint = userAuthorities.includes("ROLE_ADMIN")
        ? `${process.env.REACT_APP_API_BASE_URL}/scheduled-events/${id}`
        : userAuthorities.includes("ROLE_HR")
          ? `${process.env.REACT_APP_API_HR_URL}/scheduled-events/${id}`
          : null;

      if (!apiEndpoint) {
        console.error("Unauthorized: Unable to fetch event details.");
        setLoading(false);
        return;
      }

      const { data } = await axiosInstance.get(apiEndpoint);
      console.log("Fetched event details:", data);

      if (data?.data) {
        // Set basic event information
        setTaskName(data.data.taskName || "");
        setSelectedEventType(data.data.eventTypeId || "");

        // Handle notification types
        if (
          data.data.notificationTypes &&
          data.data.notificationTypes.length > 0
        ) {
          setSelectedNotificationTypes(
            data.data.notificationTypes.map((type) => ({
              value: type.notificationTypeId,
              label: type.notificationType || type.type,
            })),
          );
        }

        // Handle email source and related fields
        setFromEmail(
          mapDisplayToEnumValue(
            data.data.fromEmailSource || "RESPECTIVE_EMPLOYEE",
            fromEmailOptions,
          ),
        );

        // Handle specific email if that's the source
        if (
          mapDisplayToEnumValue(data.data.fromEmailSource, fromEmailOptions) ===
            "SPECIFIC" &&
          data.data.fromEmail
        ) {
          setSpecificEmail(data.data.fromEmail);
        }

        // NOTE: We do NOT try to resolve the saved "Company Email" selection
        // here. Two things made the previous version unreliable:
        //   1) It matched against `data.data.companyId` (the employer's
        //      company id) instead of the email config's `emailConfigid` -
        //      the <select> options are keyed by emailConfigid, so that
        //      value could never actually match an option.
        //   2) Even if it matched on the right field, companyEmailConfigs
        //      is fetched separately and might not have loaded yet.
        // We stash the raw record and let the dedicated matching useEffect
        // below resolve the correct emailConfigid (by comparing the saved
        // fromEmail address) once companyEmailConfigs is actually available.
        setSavedEventData(data.data);

        // Handle email destination
        setToEmail(
          mapDisplayToEnumValue(
            data.data.toEmailSourceFrom || "CANDIDATE",
            toEmailOptions,
          ),
        );
        // Handle template content
        // Check both possible structures (cronJobTemplate or eventTemplate)
        const template =
          data.data.cronJobTemplate || data.data.eventTemplate || {};

        // Handle email content (HTML) - ensure it's properly loaded into Summernote
        if (template.body) {
          setEmailContent(template.body);

          // Also set it directly in Summernote if it's already initialized
          if (isSummernoteInitialized && summernoteRef.current) {
            setTimeout(() => {
              $(summernoteRef.current).summernote("code", template.body);
            }, 200);
          }
        }
        // Handle other template fields
        setMessageHeading(template.subject || "");
        setNotificationHeader(template.notificationHeading || "");
        setNotificationBody(template.notificationMessage || "");

        // Handle notification recipients
        if (data.data.notifyToSource && data.data.notifyToSource.length > 0) {
          // Use this data to fetch and populate department, branch, role names if needed
          // First, load all required data if not already loaded
          await Promise.all([
            departments.length === 0 ? fetchDepartments() : Promise.resolve(),
            branches.length === 0 ? fetchBranches() : Promise.resolve(),
            roles.length === 0 ? fetchRoles() : Promise.resolve(),
            companyEmailConfigs.length === 0
              ? fetchCompanyEmailConfigs()
              : Promise.resolve(),
          ]);

          // Process department recipients
          const deptSources = data.data.notifyToSource.filter((source) =>
            departments.some((dept) => dept.departmentId === source.sourceId),
          );

          if (deptSources.length > 0) {
            setToEmail("DEPARTMENT");
            setSelectedDepartments(
              deptSources.map((source) => {
                const dept = departments.find(
                  (d) => d.departmentId === source.sourceId,
                );
                return {
                  value: source.sourceId,
                  label: dept
                    ? dept.departmentName
                    : `Department ${source.sourceId}`,
                };
              }),
            );
          }

          // Process branch recipients
          const branchSources = data.data.notifyToSource.filter((source) =>
            branches.some((branch) => branch.branchId === source.sourceId),
          );

          if (branchSources.length > 0) {
            setToEmail("BRANCH");
            setSelectedBranches(
              branchSources.map((source) => {
                const branch = branches.find(
                  (b) => b.branchId === source.sourceId,
                );
                return {
                  value: source.sourceId,
                  label: branch
                    ? branch.branchName
                    : `Branch ${source.sourceId}`,
                };
              }),
            );
          }

          // Process role recipients
          const roleSources = data.data.notifyToSource.filter((source) =>
            roles.some((role) => role.roleId === source.sourceId),
          );

          if (roleSources.length > 0) {
            setToEmail("ROLE");
            setSelectedRoles(
              roleSources.map((source) => {
                const role = roles.find((r) => r.roleId === source.sourceId);
                return {
                  value: source.sourceId,
                  label: role ? role.roleName : `Role ${source.sourceId}`,
                };
              }),
            );
          }

          // Process company email recipients
          if (companyEmailConfigs.length > 0) {
            const companyEmailSources = data.data.notifyToSource.filter(
              (source) =>
                companyEmailConfigs.some(
                  (config) => config.emailConfigid === source.sourceId,
                ),
            );

            if (companyEmailSources.length > 0) {
              setToEmail("COMPANY");
              setSelectedCompanyEmailToConfigs(
                companyEmailSources.map((source) => {
                  const config = companyEmailConfigs.find(
                    (c) => c.emailConfigid === source.sourceId,
                  );
                  return {
                    value: source.sourceId,
                    label: config
                      ? `${config.fromEmail} (${config.fullName})`
                      : `Company Email ${source.sourceId}`,
                  };
                }),
              );
            }
          }

          // Process employee recipients - if any exist in the data
          // This assumes your API might have employee-specific recipients
          const employeeSources = data.data.notifyToSource.filter(
            (source) =>
              source.sourceType === "EMPLOYEE" ||
              emp.some((e) => e.empId === source.sourceId),
          );

          if (employeeSources.length > 0) {
            setToEmail("SPECIFIC_EMPLOYEES");
            setSelectedEmployees(
              employeeSources.map((source) => {
                const employee = emp.find((e) => e.empId === source.sourceId);
                return {
                  value: source.sourceId,
                  label: employee
                    ? `${employee.firstName} ${employee.lastName} (${employee.email})`
                    : `Employee ${source.sourceId}`,
                };
              }),
            );
          }
        }

        // Handle specific emails list
        if (data.data.notifyToEmails && data.data.notifyToEmails.length > 0) {
          // Extract just the email strings from the objects
          setSpecificEmails(
            data.data.notifyToEmails.map((item) => item.email || ""),
          );
        }
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching event details:", error);
      console.error("Error response:", error.response?.data);
      setLoading(false);
    }
  };

  // Runs whenever the saved record OR the lookup lists change, so the
  // "Company Email" / "Specific Email Config" selects auto-select reliably
  // regardless of which async fetch (event details vs. email configs)
  // finishes first. Matches by the saved fromEmail address, since that's
  // the only value both the saved record and the config lists share.
  useEffect(() => {
    if (!savedEventData) return;

    // The API returns fromEmailSource as a display label ("Company",
    // "Specific"), not the enum used by fromEmailOptions ("COMPANY",
    // "SPECIFIC"). Map it the same way the "Email From" select does,
    // otherwise this comparison never matches and the saved company
    // email never gets selected.
    const mappedSource = mapDisplayToEnumValue(
      savedEventData.fromEmailSource,
      fromEmailOptions,
    );

    if (
      mappedSource === "COMPANY" &&
      savedEventData.fromEmail &&
      companyEmailConfigs.length > 0
    ) {
      const matchingConfig = companyEmailConfigs.find(
        (config) => config.fromEmail === savedEventData.fromEmail,
      );
      if (matchingConfig) {
        setSelectedCompanyEmail(matchingConfig.emailConfigid.toString());
      } else {
        console.warn("Selected company email not found in available options");
      }
    }

    if (
      mappedSource === "SPECIFIC" &&
      savedEventData.fromEmail &&
      specificEmailConfigs.length > 0 &&
      !specificEmailConfigs.some(
        (config) => config.fromEmail === savedEventData.fromEmail,
      )
    ) {
      console.warn("Selected specific email not found in available options");
    }
  }, [savedEventData, companyEmailConfigs, specificEmailConfigs]);

  // Helper functions to fetch necessary data if not already loaded
  const fetchDepartments = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/departments/all`,
      );
      setDepartments(response.data.data || []);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchBranches = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/branches`,
      );
      setBranches(response.data.data || []);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/roles/enabled`,
      );
      setRoles(response.data.data || []);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [deptRes, branchRes, roleRes, empRes] = await Promise.all([
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/departments/all`,
          ),
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/branches`,
          ),
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/roles/enabled`,
          ),
          axiosInstance.get(
            `${process.env.REACT_APP_API_EMPLOYEE_URL}/employees/All`,
          ),
        ]);

        setDepartments(deptRes.data.data || []);
        setBranches(branchRes.data.data || []);
        setRoles(roleRes.data.data || []);
        setEmp(empRes.data.data || []);
      } catch (error) {
        console.error("Error fetching dropdown data", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetcheventTypes = async () => {
      if (!categoryId) return;

      const authorities = user.authorities || [];

      let endpoint = "";
      if (authorities.includes("ROLE_HR")) {
        endpoint = `${process.env.REACT_APP_API_EMPLOYEE_URL}/automation-category/${categoryId}/event-types`;
      } else {
        endpoint = `${process.env.REACT_APP_API_EMPLOYEE_URL}/automation-category/${categoryId}/event-types`;
      }

      try {
        const response = await axiosInstance.get(endpoint);
        seteventType(response.data.data || []);
      } catch (error) {
        console.error("Error fetching event types", error);
      }
    };

    fetcheventTypes();
  }, [categoryId]);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Get the current content from Summernote before submitting
    if (isSummernoteInitialized && summernoteRef.current) {
      const currentContent = $(summernoteRef.current).summernote("code");
      setEmailContent(currentContent);
    }

    const userAuthorities = user.authorities || [];

    // Determine base API endpoint based on role
    let apiEndpoint;
    if (userAuthorities.includes("ROLE_ADMIN")) {
      apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/scheduled-events`;
    } else if (userAuthorities.includes("ROLE_HR")) {
      apiEndpoint = `${process.env.REACT_APP_API_HR_URL}/scheduled-events`;
    } else {
      console.error("Unauthorized: Only Admins or HR can schedule a cron job.");
      setLoading(false);
      return;
    }

    // Inside handleSubmit function, we need to find the selected company email's actual address
    let selectedCompanyEmailAddress = "";
    if (fromEmail === "COMPANY" && selectedCompanyEmail) {
      // Find the selected email config object
      const selectedConfig = companyEmailConfigs.find(
        (config) => config.emailConfigid.toString() === selectedCompanyEmail,
      );
      // Extract the email address if found
      if (selectedConfig) {
        selectedCompanyEmailAddress = selectedConfig.fromEmail;
      }
    }

    // Get the final email content from Summernote
    const finalEmailContent =
      isSummernoteInitialized && summernoteRef.current
        ? $(summernoteRef.current).summernote("code")
        : emailContent;

    // Detect if the email content contains HTML
    const isHtmlBody = containsHTML(finalEmailContent);

    // Prepare event data payload
    const eventData = {
      scheduledEventId: scheduledEventId ? parseInt(scheduledEventId) : 0,
      eventTypeId: selectedEventType,
      taskName,
      notificationTypeIds: selectedNotificationTypes.map((type) =>
        parseInt(type.value),
      ),
      toEmailSourceFrom: toEmail,
      fromEmailSource: fromEmail,
      fromEmail:
        fromEmail === "SPECIFIC"
          ? specificEmail
          : fromEmail === "COMPANY"
            ? selectedCompanyEmailAddress
            : "",
      companyId: parseInt(process.env.REACT_APP_COMPANY_ID),
      status: "ENABLED",
      employeeId: 0,
      eventTemplate: {
        templateId: 0,
        templateName: taskName,
        subject: messageHeading,
        body: finalEmailContent,
        htmlBody: isHtmlBody, // Auto-detect HTML content
        notificationHeading: notificationHeader,
        notificationMessage: notificationBody,
      },
      notifyToSource: [
        ...selectedDepartments.map((d) => ({
          id: 0,
          sourceId: d.value,
          employeeId: 0,
        })),
        ...selectedBranches.map((b) => ({
          id: 0,
          sourceId: b.value,
          employeeId: 0,
        })),
        ...selectedRoles.map((r) => ({
          id: 0,
          sourceId: r.value,
          employeeId: 0,
        })),
        ...selectedCompanyEmailToConfigs.map((c) => ({
          id: 0,
          sourceId: c.value,
          employeeId: 0,
        })),
      ],
      notifyToEmails: specificEmails.map((email) => ({
        email,
        employeeId: 0,
        id: 0,
      })),
    };

    try {
      const isUpdating = scheduledEventId && parseInt(scheduledEventId) > 0;

      // Use the same endpoint but different HTTP method based on whether we're updating or creating
      const response = isUpdating
        ? await axiosInstance.put(apiEndpoint, eventData)
        : await axiosInstance.post(apiEndpoint, eventData);

      console.log(
        `Event ${isUpdating ? "Updated" : "Created"} Successfully`,
        response.data,
      );

      onClose();
    } catch (error) {
      console.error(
        "Error scheduling event:",
        error.response?.data || error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // Fetch notification types based on role
  useEffect(() => {
    const fetchNotificationTypes = async () => {
      const authorities = user.authorities || [];

      let endpoint = "";
      if (authorities.includes("ROLE_HR")) {
        endpoint = `${process.env.REACT_APP_API_HR_URL}/notification-types/all`;
      } else if (authorities.includes("ROLE_ADMIN")) {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/notification-types/all`;
      } else {
        console.warn("No matching role for notification types");
        return;
      }

      try {
        const response = await axiosInstance.get(endpoint);
        setNotificationTypes(response.data.data || []);
      } catch (error) {
        console.error("Error fetching notification types", error);
      }
    };

    fetchNotificationTypes();
  }, []);

  useEffect(() => {
    const fetchPlaceholders = async () => {
      if (!selectedEventType) return;

      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_EMPLOYEE_URL}/placeholders/event/${selectedEventType}`,
        );

        setPlaceholders(response.data.data || []);
      } catch (error) {
        console.error("Error fetching placeholders", error);
      }
    };

    fetchPlaceholders();
  }, [selectedEventType]);

  const insertPlaceholderInActiveField = (placeholderText) => {
    // Always check Summernote first since it's the most complex field
    if (isSummernoteInitialized && summernoteRef.current) {
      // Check if activeField is emailBody OR if Summernote has focus OR if no other field has focus
      const summernoteElement = $(summernoteRef.current).next(".note-editor");
      const summernoteHasFocus =
        summernoteElement.find(".note-editable").is(":focus") ||
        summernoteElement.find(".note-editable").hasClass("focus");

      if (
        activeField === "emailBody" ||
        summernoteHasFocus ||
        !document.activeElement ||
        (document.activeElement !== notificationHeaderRef.current &&
          document.activeElement !== notificationBodyRef.current &&
          document.activeElement !== messageHeadingRef.current)
      ) {
        // Focus and insert into Summernote
        $(summernoteRef.current).summernote("focus");
        setTimeout(() => {
          $(summernoteRef.current).summernote("insertText", placeholderText);
        }, 50);
        return;
      }
    }

    // Handle other input fields
    let targetRef = null;
    let setValue = null;
    let currentValue = "";

    switch (activeField) {
      case "notificationHeader":
        targetRef = notificationHeaderRef;
        setValue = setNotificationHeader;
        currentValue = notificationHeader;
        break;
      case "notificationBody":
        targetRef = notificationBodyRef;
        setValue = setNotificationBody;
        currentValue = notificationBody;
        break;
      case "messageHeading":
        targetRef = messageHeadingRef;
        setValue = setMessageHeading;
        currentValue = messageHeading;
        break;
      default:
        // Check which field currently has focus
        if (document.activeElement === notificationHeaderRef.current) {
          targetRef = notificationHeaderRef;
          setValue = setNotificationHeader;
          currentValue = notificationHeader;
        } else if (document.activeElement === notificationBodyRef.current) {
          targetRef = notificationBodyRef;
          setValue = setNotificationBody;
          currentValue = notificationBody;
        } else if (document.activeElement === messageHeadingRef.current) {
          targetRef = messageHeadingRef;
          setValue = setMessageHeading;
          currentValue = messageHeading;
        } else {
          // If no field has focus, default to email body
          if (isSummernoteInitialized && summernoteRef.current) {
            $(summernoteRef.current).summernote("focus");
            setTimeout(() => {
              $(summernoteRef.current).summernote(
                "insertText",
                placeholderText,
              );
            }, 50);
          }
          return;
        }
        break;
    }

    if (targetRef.current && setValue) {
      const element = targetRef.current;
      const start = element.selectionStart || 0;
      const end = element.selectionEnd || 0;
      const newValue =
        currentValue.substring(0, start) +
        placeholderText +
        currentValue.substring(end);
      setValue(newValue);

      setTimeout(() => {
        element.selectionStart = element.selectionEnd =
          start + placeholderText.length;
        element.focus();
      }, 0);
    }
  };

  return (
    <div className="template-content">
      <h1 className="display6">Notification Job</h1>
      <div className="eventform-header">
        <button type="button" className="back-button" onClick={onClose}>
          ← Back
        </button>
      </div>

      {loading && <LoadingScreen />}
      <form className="template-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label>Notification Name</label>
            <input
              type="text"
              value={taskName}
              onChange={(e) => setTaskName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Notification Type</label>
            <select
              value={selectedEventType}
              onChange={(e) => {
                const selectedId = Number(e.target.value);
                console.log("Selected Event Type ID:", selectedId);
                setSelectedEventType(selectedId);
              }}
              required
            >
              <option value="" disabled>
                Select Notification Type
              </option>
              {eventType.map((type) => (
                <option key={type.eventId} value={type.eventId}>
                  {type.eventName}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Trigger Types</label>
            <Select
              isMulti
              options={notificationTypes.map((type) => ({
                value: type.notificationTypeId,
                label: type.type,
              }))}
              value={selectedNotificationTypes}
              onChange={(selected) =>
                setSelectedNotificationTypes(selected || [])
              }
              required
              placeholder="Select Notification Types"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>

          {/* Email From dropdown with RESPECTIVE_ACCOUNTANT added */}
          <div className="form-group">
            <label>Email From</label>
            <select
              value={fromEmail}
              onChange={(e) => setFromEmail(e.target.value)}
            >
              {fromEmailOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {fromEmail === "SPECIFIC" && (
            <div className="form-group">
              <label>Select Email Configuration</label>
              <select
                value={specificEmail}
                onChange={(e) => setSpecificEmail(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Email Configuration
                </option>
                {specificEmailConfigs.map((config) => (
                  <option key={config.emailConfigid} value={config.fromEmail}>
                    {config.fromEmail} ({config.fullName})
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* Dropdown for company email configurations */}
          {fromEmail === "COMPANY" && (
            <div className="form-group">
              <label>Select Company Email</label>
              <select
                value={selectedCompanyEmail}
                onChange={(e) => setSelectedCompanyEmail(e.target.value)}
                required
              >
                <option value="" disabled>
                  Select Company Email
                </option>
                {companyEmailConfigs.map((config) => (
                  <option
                    key={config.emailConfigid}
                    value={config.emailConfigid}
                  >
                    {config.fromEmail} ({config.fullName})
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* Emails To dropdown with RESPECTIVE_ACCOUNTANT added */}
          <div className="form-group">
            <label>Emails To</label>
            <select
              value={toEmail}
              onChange={(e) => setToEmail(e.target.value)}
            >
              {toEmailOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          {toEmail === "DEPARTMENT" && (
            <div className="form-group">
              <label>Select Department</label>
              <Select
                isMulti
                options={departments.map((dept) => ({
                  value: dept.departmentId,
                  label: dept.departmentName,
                }))}
                value={selectedDepartments}
                onChange={(selected) => setSelectedDepartments(selected || [])}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          )}
          {toEmail === "BRANCH" && (
            <div className="form-group">
              <label>Select Branch</label>
              <Select
                isMulti
                options={branches.map((branch) => ({
                  value: branch.branchId,
                  label: branch.branchName,
                }))}
                value={selectedBranches}
                onChange={(selected) => setSelectedBranches(selected || [])}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          )}
          {toEmail === "ROLE" && (
            <div className="form-group">
              <label>Select Role</label>
              <Select
                isMulti
                options={roles.map((role) => ({
                  value: role.roleId,
                  label: role.roleName,
                }))}
                value={selectedRoles}
                onChange={(selected) => setSelectedRoles(selected || [])}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          )}
          {toEmail === "SPECIFIC_EMPLOYEES" && (
            <div className="form-group">
              <label>Select Employees</label>
              <Select
                isMulti
                options={emp.map((emp) => ({
                  value: emp.empId,
                  label: `${emp.firstName} ${emp.lastName} (${emp.email})`,
                }))}
                value={selectedEmployees}
                onChange={(selected) => setSelectedEmployees(selected || [])}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          )}
          {/* New dropdown for company email configurations as recipients */}
          {toEmail === "COMPANY" && (
            <div className="form-group">
              <label>Select Company Emails</label>
              <Select
                isMulti
                options={companyEmailConfigs.map((config) => ({
                  value: config.emailConfigid,
                  label: `${config.fromEmail} (${config.fullName})`,
                }))}
                value={selectedCompanyEmailToConfigs}
                onChange={(selected) =>
                  setSelectedCompanyEmailToConfigs(selected || [])
                }
                required
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          )}
        </div>

        <div className="form-with-placeholders">
          <div className="form-containter">
            <div className="form-group">
              <label>In App Notification Header</label>
              <input
                ref={notificationHeaderRef}
                type="text"
                value={notificationHeader}
                onChange={(e) => setNotificationHeader(e.target.value)}
                onFocus={() => setActiveField("notificationHeader")}
              />
            </div>

            <div className="form-group">
              <label>In App Notification Content</label>
              <textarea
                ref={notificationBodyRef}
                value={notificationBody}
                onChange={(e) => setNotificationBody(e.target.value)}
                onFocus={() => setActiveField("notificationBody")}
              />
            </div>

            <div className="form-group">
              <label>Email Subject</label>
              <input
                ref={messageHeadingRef}
                type="text"
                value={messageHeading}
                onChange={(e) => setMessageHeading(e.target.value)}
                onFocus={() => setActiveField("messageHeading")}
                required
              />
            </div>

            <div className="summernote-editor">
              <label>Email Body </label>
              <div ref={summernoteRef} style={{ minHeight: "300px" }} />
            </div>
          </div>

          <div className="shared-placeholders-section">
            <h4>Placeholders</h4>
            <div className="placeholder-buttons-shared">
              {placeholders.map((ph) => (
                <button
                  key={ph.placeHolderId}
                  type="button"
                  onClick={() => insertPlaceholderInActiveField(ph.placeHolder)}
                  className="placeholder-btn"
                >
                  {ph.placeHolder}
                </button>
              ))}
            </div>
            {!activeField && (
              <p className="placeholder-hint">
                Focus on any input field on the left to insert placeholders
                there
              </p>
            )}
          </div>
        </div>

        <div className="button-group">
          <button type="submit" className="submit-button">
            Schedule Event Job
          </button>
        </div>
      </form>
    </div>
  );
};

export default EventForm;
